import DetailsMemberUser from "./account/DetailsMemberUser";
import NavMenu from "./nav-menu/nav-menu";
import SystemErrors from "./shared/SystemErrors";
import Footer from "./shared/Footer";
import DownloadProgressModal from "./reports/DownloadProgressModal";

const Layout = ({ children }) => {
  return (
    <div>
      <NavMenu />
      <SystemErrors />
      {children}
      <DetailsMemberUser />
      <Footer />
      <DownloadProgressModal />
    </div>
  );
};

export default Layout;